import { Rating } from 'primereact/rating'

const BaseRating = (props) => {
  return <Rating {...props} className={`${props.custom ? props.custom: ''} ${props.extra ? props.extra : ''} stars--yellow`} />
}

export default BaseRating
